<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Blocked Phone Number</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <mat-form-field class="flex-full">
        <mat-label>Phone Number</mat-label>
        <input
          matInput
          autocomplete="off"
          type="text"
          formControlName="phoneNumber"
          id="phoneNumber"
          #phoneNumber
          />
          @if (form.get('phoneNumber')?.hasError('required')) {
            <mat-error> Phone Number is Required. </mat-error>
          }
          @if (form.get('phoneNumber')?.hasError('pattern')) {
            <mat-error>
              Please enter a valid phone number.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="flex-full">
          <mat-label>Comment</mat-label>
          <input matInput autocomplete="off" type="text" formControlName="comment" id="comment" />
          @if (form.get('comment')?.hasError('maxlength')) {
            <mat-error>
              Comments limited to 50 characters.
            </mat-error>
          }
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button type="button" title="submitAndAddAnother" (click)="onCreateAndAddAnother()" mat-stroked-button
          >Save and Add Another</button
          >
          <button type="submit" title="Create" mat-raised-button color="primary">Save</button>
        </mat-dialog-actions>
      </form>
    </lcs-loading-overlay>
